const ASSETS = "https://customer-assets-39nsmqrw.emergentagent.net/job_6b41783a-7784-43c7-b37b-9560fbf9b828/artifacts";

export const VILLA_IMAGE = `${ASSETS}/btujac8i_FOTO%20VILLA%20SFONDO.png`;

const ROCC = "https://customer-assets-4nw71qhi.emergentagent.net/job_venetian-villas/artifacts";

export const AMENITY_IMAGES = {
  pool: `${ROCC}/jsq8a25m_piscina6.png`,
  tennis: `${ROCC}/ulok6n5c_tennis%20court%20and%20football%20pitch.webp`,
  park: `${ROCC}/pnsn0for_esterno%20pasin.webp`,
};

export const DRONE_PHOTO = `${ROCC}/17xj4fjx_foto%20drone%20parco.png`;

export const POOL_PHOTOS = [
  `${ROCC}/zfumc1ba_piscina3.png`,
  `${ROCC}/avqgzm4o_piscina%20per%20tutti%20gli%20ospiti.webp`,
  `${ROCC}/6et4vhcm_esterno%20piscina.png`,
  `${ROCC}/rpwuxvk0_piscina1.webp`,
  `${ROCC}/p1zkx30w_gazebo%20piscina.jpg`,
  `${ROCC}/p86vpy6p_zona%20piscina.jpg`,
];

export const TENNIS_PHOTOS = [
  `${ROCC}/gwwx6m9t_football%20pitch.jpg`,
];

export const PARK_PHOTOS = [
  `${ROCC}/zj9ajevz_caronte%20parco.png`,
  `${ROCC}/5j142xob_foto%20parco4.png`,
  `${ROCC}/m8ouaiz2_parco5.png`,
  `${ROCC}/glk9qn7q_boschetto.png`,
  `${ROCC}/6atfry40_parco6.png`,
  `${ROCC}/7pe1tzvi_parco7.png`,
  `${ROCC}/vp268w9o_parc8.png`,
  `${ROCC}/5s9rg1ur_parco9.png`,
  `${ROCC}/j2c6r3dj_fontana%20parco.png`,
  `${ROCC}/pnsn0for_esterno%20pasin.webp`,
  `${ROCC}/srkrn0ah_parco4.jpg`,
  `${ROCC}/t20wikw3_entrata%204.jpg`,
  `${ROCC}/38pgdd2y_parco3.jpg`,
  `${ROCC}/ry1omttt_boschetto2.jpg`,
  `${ROCC}/h1xqbmt3_parco2.jpg`,
];

export const APARTMENTS = [
  {
    id: "ca-degli-stefani-a",
    name: "Ca' Degli Stefani A",
    guests: 4,
    pricing: { low: 160, mid: 170, high: 200 },
    image: `${ASSETS}/04lst9ml_stefani%20A%20soggiorno.jpg`,
    gallery: [
      `${ROCC}/mh3gv3mg_soggiorno%20stefani%20A.webp`,
      `${ROCC}/dxktwe8e_scale%20stefani%20A.webp`,
      `${ROCC}/lvvh5sze_1camera1stefani%20A.webp`,
      `${ROCC}/qsvl12tx_camera2%20stefani%20A.webp`,
      `${ROCC}/bi4r3tva_bagno1stefani%20A.webp`,
      `${ROCC}/uh0lpree_esterno%20stefani%20A.webp`,
      `${ROCC}/9ivctwym_esterno2%20stefani%20A.webp`,
      `${ROCC}/u2pbeys6_piscina1.webp`,
      `${ROCC}/avqgzm4o_piscina%20per%20tutti%20gli%20ospiti.webp`,
      `${ROCC}/ulok6n5c_tennis%20court%20and%20football%20pitch.webp`,
    ],
    it: "Giardino privato recintato e vista sul parco: una camera matrimoniale, una camera con due letti singoli, due bagni, cucina e soggiorno. Perfetto per 4 ospiti.",
    en: "Private fenced garden and park view: one double bedroom, one twin bedroom, two bathrooms, kitchen and living room. Perfect for 4 guests.",
  },
  {
    id: "barchessa",
    name: "Barchessa",
    guests: 4,
    pricing: { low: 170, mid: 175, high: 210 },
    image: `${ASSETS}/xauv21rg_barchessa%20soggiorno.jpg`,
    gallery: [
      `${ROCC}/y99v6xc0_barchessa%20soggiorno.webp`,
      `${ROCC}/r7dt1a38_ingresso2barchessa.webp`,
      `${ROCC}/st3vtuk5_barchessa%20cucina%202.webp`,
      `${ROCC}/dsm64kpc_barchessa%20cucina%202.webp`,
      `${ROCC}/ywqaxe8m_barchessa%20pranzo%20zone.webp`,
      `${ROCC}/xriocmz3_room2barchessa.webp`,
      `${ROCC}/iskf57qw_barchessa%20bagno.webp`,
      `${ROCC}/rpwuxvk0_piscina1.webp`,
      `${ROCC}/jl3owhcg_tennis%20court%20and%20football%20pitch.webp`,
    ],
    it: "Vista su Villa Navagero: una camera matrimoniale, una camera con due letti singoli, un bagno, cucina, soggiorno e ufficio. Perfetto per 4 ospiti.",
    en: "Overlooking Villa Navagero: one double bedroom, one twin bedroom, one bathroom, kitchen, living room and study. Perfect for 4 guests.",
  },
  {
    id: "ca-degli-stefani-c",
    name: "Ca' Degli Stefani C",
    guests: 4,
    pricing: { low: 165, mid: 175, high: 210 },
    image: `${ASSETS}/u7k7h20t_STEFANI%20C%20soggiorno.jpg`,
    gallery: [
      `${ROCC}/1ege1l34_soggiorno%20stefani%20C.webp`,
      `${ROCC}/cawzp63s_ingresso3stefani%20c.webp`,
      `${ROCC}/65ou26bg_cucina1%20stefani%20C.webp`,
      `${ROCC}/bd23wndn_cucina2%20stefani%20C.webp`,
      `${ROCC}/4old8djm_1camera1%20stefani%20c.webp`,
      `${ROCC}/wjecqos6_camera2%20stefani%20C.webp`,
      `${ROCC}/ob427mrc_1bagno1%20stefani%20c.webp`,
      `${ROCC}/6ndoqr2b_1bagnostefani%20C.webp`,
      `${ROCC}/aahekbqk_bagno%202%20stefani%20C.webp`,
      `${ROCC}/o78e3lvx_1esterno%20stefani%20C.webp`,
    ],
    it: "Giardino privato recintato con vista sulla piscina e sul parco: due camere matrimoniali, due bagni, cucina e soggiorno. Perfetto per 4 ospiti.",
    en: "Private fenced garden with pool and park view: two double bedrooms, two bathrooms, kitchen and living room. Perfect for 4 guests.",
  },
  {
    id: "ca-dei-pasin",
    name: "Ca' Dei Pasin",
    guests: 6,
    pricing: { low: 150, mid: 170, high: 200 },
    image: `${ASSETS}/uhhgn6oz_PASIN%20soggiorno.png`,
    gallery: [
      `${ROCC}/fsttje12_soggiorno1pasin.webp`,
      `${ROCC}/88untem0_pasin%20zona%20pranzo.webp`,
      `${ROCC}/ji4i1n4t_pasin2.webp`,
      `${ROCC}/s3s0t738_camera1pasin.webp`,
      `${ROCC}/5fnt3hv5_camera%202%20pasin.webp`,
      `${ROCC}/8r61o23k_camera3pasin.webp`,
      `${ROCC}/wi3fowr7_bagno1pasin.webp`,
      `${ROCC}/pnsn0for_esterno%20pasin.webp`,
      `${ROCC}/ead9ajhv_esterno2%20pasin.webp`,
      `${ROCC}/rpwuxvk0_piscina1.webp`,
    ],
    it: "Al primo piano: tre camere da letto, due bagni, cucina e soggiorno. Perfetto per 6 ospiti.",
    en: "On the first floor: three bedrooms, two bathrooms, kitchen and living room. Perfect for 6 guests.",
  },
  {
    id: "ca-rocchetto",
    name: "Ca' Rocchetto",
    guests: 4,
    pricing: { low: 150, mid: 170, high: 200 },
    image: `${ROCC}/5ku432nq_soggiorno%20rocchetto.png`,
    gallery: [
      `${ROCC}/o71c6tdu_ROCCHETTO%20sooggiorno.png`,
      `${ROCC}/6vtjbjii_room%20rocchetto.png`,
      `${ROCC}/6l3l7434_room2rocchetto.png`,
      `${ROCC}/vzcu4r0n_bagnno%20rocchetto.png`,
    ],
    it: "Una camera matrimoniale, una camera con due letti singoli, due bagni, cucina e soggiorno. Perfetto per 4 ospiti.",
    en: "One double bedroom, one twin bedroom, two bathrooms, kitchen and living room. Perfect for 4 guests.",
  },
];

// low: Oct–Apr · mid: May–Jun · high: Jul–Sep
export const seasonFor = (monthIdx) => {
  const m = monthIdx + 1;
  if (m === 5 || m === 6) return "mid";
  if (m >= 7 && m <= 9) return "high";
  return "low";
};

export const seasonalTotal = (pricing, from, to) => {
  let total = 0;
  const d = new Date(from);
  while (d < to) {
    total += pricing[seasonFor(d.getMonth())];
    d.setDate(d.getDate() + 1);
  }
  return total;
};
